import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=b6587de4&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=js&"
export * from "./ContentCard.vue?vue&type=script&lang=js&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=b6587de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6587de4",
  null
  
)

export default component.exports